<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "targetSplit"
}
</script>

<style scoped>

</style>